module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/configuration/configuration.component.html
// module id = 1231
// module chunks = 0